<template>

  <v-container fluid class="pa-0">
    <v-row>

      <v-col :cols="cols">
        <v-combobox
          persistent-hint
          @change="changed0"
          v-model="geographic0"
          :items="geographicOptions0"
          :label="$t(geographicHeirarchy[0])"
          :hint="$t('hint')"
          single-line
          v-bind:rules="rules"
        ></v-combobox >
      </v-col>
    
      <v-col :cols="cols">
        <v-combobox
          persistent-hint
          @change="changed1"
          v-model="geographic1"
          :items="geographicOptions1"
          :label="$t(geographicHeirarchy[1])"
          :hint="$t('hint')"
          single-line
          v-bind:rules="rules"
        ></v-combobox >
      </v-col>
    
      <v-col :cols="cols">
        <v-combobox
          persistent-hint
          v-model="geographic2"
          :items="geographicOptions2"
          :label="$t(geographicHeirarchy[2])"
          :hint="$t('hint')"
          single-line
          v-bind:rules="rules"
        ></v-combobox >
      </v-col>
    
<!--      <v-col :cols="cols" v-if="showLocality">-->
<!--        <v-combobox-->
<!--          persistent-hint-->
<!--          v-model="geographic3"-->
<!--          :items="localities"-->
<!--          :label="$t('Locality')"-->
<!--          :hint="$t('hint')"-->
<!--          single-line-->
<!--          @change="setLocality"-->
<!--        ></v-combobox >-->
<!--      </v-col>-->

    </v-row>
  </v-container>

</template>

<script>

  // DEPRECATED!!

  export default {

    props: ['value', 'rules'],

    data: () => ({
      geographic0: '',
      geographic1: '',
      geographic2: '',
      geographicOptions0: [],
      geographicOptions1: [],
      geographicOptions2: [],
    }),

    computed: {
      result() { return [this.geographic0, this.geographic1, this.geographic2]; },
      geographicHeirarchy() { return this.$store.getters.settings.geographicHeirarchy; },
      geographicStructure() { return this.$store.getters.settings.geographicStructure; },
      partnerCode() { return this.$store.getters.settings.partnerCode; },
      // showLocality() { return (this.partnerCode==='hr_co'); },

      // Next are to prepopulate geographic3
      customers() { return this.$store.getters.customers; },
      customerRegions() { return this.customers.map(e => ((e || {}).demographic || {}).geographicsArray ).filter(e => e) },
      customerLocalities() { return this.customerRegions.filter( e => (e[0]===this.geographic0 && e[1]===this.geographic1 && e[2]===this.geographic2 ) ).map(e=>e[3]).filter(e => e); },
      treeLocalities() { return this.$store.getters.trees.map( e=> (e || {}).region ).filter( e => e && (e[0]===this.geographic0 && e[1]===this.geographic1 && e[2]===this.geographic2 ) ).map(e=>e[3]).filter(e => e); },
      localities() { return [...new Set(this.customerLocalities.concat(this.treeLocalities))]; },

      cols() {
        // (this.showLocality ? 3 : 4)
        let c = undefined;
        if (this.$vuetify.breakpoint.name=='xs') {
          c = 12;
        } else {
          c = 4;
        }
        return c;
      },
    },

    watch: {
      value: {
        immediate: true,
        handler(to) {
          if (to) {
            this.geographic0 = to[0] || '';
            this.geographic1 = to[1] || '';
            this.geographic2 = to[2] || '';
          } else {
            this.geographic0 = '';
            this.geographic1 = '';
            this.geographic2 = '';
          }
          this.setGeographicOptions();
        }
      },
      result(to) { this.$emit('input', to); },
    },

    methods: {

      setLocality(e) { this.geographic3 = e; },

      setGeographicOptions() {
        this.geographicOptions0 = this.getGeographicOptions0();
        this.geographicOptions1 = this.getGeographicOptions1();
        this.geographicOptions2 = this.getGeographicOptions2();
      },

      getGeographicOptions0() { return Object.keys(this.geographicStructure).sort(); },
      getGeographicOptions1() {
        let places = {};
        if (this.geographic0) { places = this.geographicStructure[this.geographic0]; }
        places = places || {};
        return Object.keys(places).sort();
      },
      getGeographicOptions2() {
        let places = [];
        if (this.geographic0 && this.geographic1) { places = (this.geographicStructure[this.geographic0] || {})[this.geographic1]; }
        places = places || [];
        return places.sort();
      },


      changed0() {
        this.geographic1 = '';
        this.geographic2 = '';
        this.geographicOptions1 = this.getGeographicOptions1();
        this.geographicOptions2 = this.getGeographicOptions2();
      },
      changed1() {
        this.geographic2 = '';
        this.geographicOptions2 = this.getGeographicOptions2();
      },
    },

  }
</script>


<i18n>
{
  "en": {
    "Area": "Area",
    "District": "District",
    "Province": "Province",
    "Region": "Region",
    "Town": "Town",
    "Village": "Village",
    "Ward": "Ward",
    "Locality": "Locality",
    "hint": "Select from menu, or enter new"
  },
  "es": {
    "Area": "Municipio",
    "District": "District",
    "Province": "Province",
    "Region": "Departamento",
    "Town": "Ciudad / Pueblo",
    "Village": "Village",
    "Ward": "Ward",
    "Locality": "Vereda",
    "hint": "Seleccionar del menú o escribir nuevo"
  },
  "sw": {
    "Area": "Eneo",
    "District": "Wilaya",
    "Province": "Mkoa",
    "Region": "Mkoa",
    "Town": "Mji",
    "Village": "Kijiji",
    "Ward": "Kata",
    "Locality": "Eneo",
    "hint": "Chagua kutoka kwa menyu, au ingiza mpya"
  }
}
</i18n>
